import {useWebsiteChatEnabled} from '~/composables/useWebsiteChatEnabled.js'

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()
    const showWebsiteChat = useWebsiteChatEnabled()
    const disableThirdParty = ['local', 'dev'].includes(String(config.public.APP_ENV)) || import.meta.dev

    if (process.client && !disableThirdParty) {
        setTimeout(() => {
            if (showWebsiteChat.value) {
                return
            }

            function initFreshChat() {
                window.fcWidget.init({
                    token: '2ffed682-a0a3-44c3-988b-4537f5221951',
                    host: 'https://hillceramic-help.freshchat.com',
                    locale: config.public.locale || 'sv',
                });
            }

            function initialize(i, t) {
                var e;
                if (i.getElementById(t)) {
                    initFreshChat();
                } else {
                    e = i.createElement('script');
                    e.id = t;
                    e.async = true;
                    e.src = 'https://hillceramic-help.freshchat.com/js/widget.js';
                    e.onload = initFreshChat;
                    i.head.appendChild(e);
                }
            }

            function initiateCall() {
                initialize(document, 'Freshchat-js-sdk');
            }

            initiateCall();
        }, 3000);
    }
});
